
import { withAuthRetry } from '../utils/authRetry';
import { FinalizeReviewRequest, FinalizeReviewResponse } from '../finalizereview';
import { Section } from '../schema';
import { getServiceUrl } from '../utils/api';

export async function finalizeReview(
    caseId: string,
    reviewedSections: Section[],
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<FinalizeReviewResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/protobuf',
            'Authorization': 'Bearer ' + token
        };

        const url = getServiceUrl('reviewservice', 'finalizereview');

        const request: FinalizeReviewRequest = {
            caseId,
            reviewedSections
        };
        const bodyBytes = FinalizeReviewRequest.encode(request).finish();

        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: bodyBytes
        });
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): FinalizeReviewResponse => {
        if (bytes.length === 0) {
            return { success: true };
        }
        return FinalizeReviewResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
